import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "regenerator-runtime/runtime.js";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  mutation updateShopperLanguagePreference(\n    $input: UpdateShopperLanguagePreferenceInput!\n  ) {\n    updateShopperLanguagePreference(input: $input) {\n      status\n    }\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  query initStoreCookies {\n    viewer {\n      id\n      role\n      store {\n        id\n        setting {\n          locale\n          currency\n        }\n      }\n\n      ...viewerFragment\n    }\n  }\n\n  ", "\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  fragment viewerFragment on User {\n    id\n    locale\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

// import
import { gql } from '@apollo/client';
import { defaultCurrency } from '@meepshop/context/lib/Currency';
import { withCookies } from '@meepshop/cookies'; // definition

var viewerFragment = gql(_templateObject());
var initStoreCookies = gql(_templateObject2(), viewerFragment);
var mutation = gql(_templateObject3());
var isLoading = false;

var _withCookies = withCookies( /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var _data$viewer, _data$viewer$store, _data$viewer$store$se, _data$viewer2, _data$viewer2$store, _data$viewer2$store$s, _data$viewer3, _data$viewer4;

    var client, i18n, currentLanguage, cookie, _yield$client$query, data, storeCurrencies, storeLocales, locale, currency, isLogin, language, identity, promoCode;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            client = _ref.client, i18n = _ref.i18n, currentLanguage = _ref.language, cookie = _ref.cookie;
            _context.next = 3;
            return client.query({
              query: initStoreCookies
            });

          case 3:
            _yield$client$query = _context.sent;
            data = _yield$client$query.data;
            // 店家設定的幣別選項
            storeCurrencies = (data === null || data === void 0 ? void 0 : (_data$viewer = data.viewer) === null || _data$viewer === void 0 ? void 0 : (_data$viewer$store = _data$viewer.store) === null || _data$viewer$store === void 0 ? void 0 : (_data$viewer$store$se = _data$viewer$store.setting) === null || _data$viewer$store$se === void 0 ? void 0 : _data$viewer$store$se.currency) || ['TWD']; // 店家設定的語系選項

            // 店家設定的語系選項
            storeLocales = (data === null || data === void 0 ? void 0 : (_data$viewer2 = data.viewer) === null || _data$viewer2 === void 0 ? void 0 : (_data$viewer2$store = _data$viewer2.store) === null || _data$viewer2$store === void 0 ? void 0 : (_data$viewer2$store$s = _data$viewer2$store.setting) === null || _data$viewer2$store$s === void 0 ? void 0 : _data$viewer2$store$s.locale) || ['zh_TW']; // 如果有登入後會拿到使用者設定的 locale，不然就拿 Browser 切換語系所設定的

            // 如果有登入後會拿到使用者設定的 locale，不然就拿 Browser 切換語系所設定的
            locale = (data === null || data === void 0 ? void 0 : (_data$viewer3 = data.viewer) === null || _data$viewer3 === void 0 ? void 0 : _data$viewer3.locale) || cookie.get('next-i18next'); // 幣值順序：
            // 1. 若消費者有進行調整(browser 有設定幣別)，則會有 cookie.get('currency')
            // 2. cookies.currency 為店家後臺設定的首個幣值
            // 3. 若店家沒有設定，則顯示 TWD (defaultCurrency)（原則上不會有這個問題)

            // 幣值順序：
            // 1. 若消費者有進行調整(browser 有設定幣別)，則會有 cookie.get('currency')
            // 2. cookies.currency 為店家後臺設定的首個幣值
            // 3. 若店家沒有設定，則顯示 TWD (defaultCurrency)（原則上不會有這個問題)
            currency = storeCurrencies.includes(cookie.get('currency')) ? cookie.get('currency') : storeCurrencies[0] || defaultCurrency;
            isLogin = (data === null || data === void 0 ? void 0 : (_data$viewer4 = data.viewer) === null || _data$viewer4 === void 0 ? void 0 : _data$viewer4.role) === 'SHOPPER';

            language = function () {
              if (storeLocales.includes(locale)) return locale;
              if (storeLocales.includes(currentLanguage)) return currentLanguage;
              return storeLocales[0];
            }();

            if (!language) {
              _context.next = 20;
              break;
            }

            if (!(language !== currentLanguage)) {
              _context.next = 15;
              break;
            }

            _context.next = 15;
            return i18n.changeLanguage(language);

          case 15:
            if (!(!isLoading && isLogin && language !== locale)) {
              _context.next = 20;
              break;
            }

            isLoading = true;
            _context.next = 19;
            return client.mutate({
              mutation: mutation,
              variables: {
                input: {
                  locale: language
                }
              },
              update: function update(cache, _ref3) {
                var updateShopperLanguagePreference = _ref3.data.updateShopperLanguagePreference;
                if (!(data !== null && data !== void 0 && data.viewer.id) || updateShopperLanguagePreference.status !== 'OK') return;
                cache.writeFragment({
                  id: data.viewer.id,
                  fragment: viewerFragment,
                  data: {
                    __typename: 'User',
                    id: data.viewer.id,
                    locale: language
                  }
                });
              }
            });

          case 19:
            isLoading = false;

          case 20:
            identity = cookie.get('identity');
            promoCode = cookie.get('promoCode');
            return _context.abrupt("return", {
              currency: currency,
              identity: identity,
              promoCode: promoCode
            });

          case 23:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function (_x) {
    return _ref2.apply(this, arguments);
  };
}()),
    appWithCookies = _withCookies.appWithCookies,
    getServerSideCookiesContextProps = _withCookies.getServerSideCookiesContextProps,
    getClientSideCookiesContextProps = _withCookies.getClientSideCookiesContextProps;

export { appWithCookies, getServerSideCookiesContextProps, getClientSideCookiesContextProps };